import React from 'react';
import {Button} from 'reactstrap';
import checkPermission from '../../../Components/Hooks/PermissionHook';
import { useDispatch, useSelector } from 'react-redux';
import { toggleCompanyModal } from '../../../slices/modals/reducer';
import { getBillingSuccess } from '../../../slices/auth/settings/reducer';
import { getBilling } from '../../../slices/auth/settings/thunk';
import { createSelector } from 'reselect';

function CompanyEditBtn() {
  const dispatch = useDispatch();
  const selectState = createSelector(state => state, state => ({
    companyInfo: state.MenuData.client,
    permission: state.Permission.permission,
    company: state.MenuData.client,
  }));
  const { companyInfo, permission } = useSelector(selectState);  
  
  async function showCompanyEditModal() {
    dispatch(toggleCompanyModal());
    const billing = await dispatch(getBilling(companyInfo.billingId));
    dispatch(getBillingSuccess(billing.data[0]));
  }
  
  if (companyInfo?._id && Object.keys(permission['companies'].length > 0) && permission['companies'][companyInfo._id]?.permissionsWK.includes('companyDetailsEdit')) {
    return (
      <React.Fragment>
          <Button className="btn btn-light text-secondary fs-15" onClick={showCompanyEditModal}>
            <i className="ri-pencil-fill align-bottom"></i>
          </Button>
      </React.Fragment>
    )  
  } else {
    return null;
  }
  
}

export default CompanyEditBtn
